@switch (context ? context.type : '') {
    @default {
        <fui-edit-autocomplete-input [control]="control" [disabled]="disabled" [field]="valueField" #input
                                     [key]="labelField" [label]="label" [loading]="loading" [(ngModel)]="value"
                                     (focussed$)="onFocussed($event)" [options]="options"
                                     [placeholder]="placeholder" (filtered$)="filtered$.emit($event)">
        </fui-edit-autocomplete-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-autocomplete-input [control]="control" [disabled]="disabled" [field]="valueField" #input
                                       [key]="labelField" [label]="label" [loading]="loading" [(ngModel)]="value"
                                       (focussed$)="onFocussed($event)" [options]="options"
                                       [placeholder]="placeholder" (filtered$)="filtered$.emit($event)">
        </fui-filter-autocomplete-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-autocomplete-input [control]="control" [disabled]="disabled" [field]="valueField" #input
                                       [key]="labelField" [label]="label" [loading]="loading" [(ngModel)]="value"
                                       (focussed$)="onFocussed($event)" [options]="options"
                                       [placeholder]="placeholder" (filtered$)="filtered$.emit($event)">
            <fui-icon [height]="16" [icon]="'search-group'" [width]="16"></fui-icon>
        </fui-inline-autocomplete-input>
    }
    @case (contextType.PILL) {
        <fui-autocomplete-pill [control]="control" [disabled]="disabled" [field]="valueField" #input
                               [key]="labelField" [label]="label" [loading]="loading" [(ngModel)]="value"
                               (focussed$)="onFocussed($event)" [options]="options"
                               [placeholder]="placeholder" (filtered$)="filtered$.emit($event)">
        </fui-autocomplete-pill>
    }
}
